import { useBusinessEntity } from '@commenda/api';
import {
  CountryCode,
  FullscreenModal,
  FullscreenModalContent,
  Loading,
} from '@commenda/kakashi';
import { IncorporationFormHeader } from '../../form-builder/components/new-incorp-layout';
import { AddUltimateBeneficialOwnerForm } from './forms/AddUltimateBeneficialOwnerForm';

interface AddUltimateBeneficialOwnerPageProps {
  corporationId: number;
  onClose: () => void;
  onSuccess?: (message: string) => void;
  onError?: (message: string) => void;
}

export const AddUltimateBeneficialOwnerPage = ({
  corporationId,
  onClose,
  onSuccess,
  onError,
}: AddUltimateBeneficialOwnerPageProps) => {
  const { data: businessEntity, isLoading } = useBusinessEntity(corporationId);

  const entityName = businessEntity?.generalCorporationInfo?.legalName ?? '';
  const entityCountry =
    businessEntity?.generalCorporationInfo?.incorporationCountry;

  return (
    <FullscreenModal isOpen onClose={onClose} enableEscapeKey>
      <IncorporationFormHeader
        entity={
          entityName && entityCountry
            ? { name: entityName, countryCode: entityCountry as CountryCode }
            : undefined
        }
        onClose={onClose}
      />

      <FullscreenModalContent className="bg-bg-light flex justify-center overflow-y-auto">
        {isLoading || !businessEntity ? (
          <div className="flex flex-1 items-center justify-center py-7xl">
            <Loading />
          </div>
        ) : (
          <div className="flex w-[562px] max-w-full flex-col gap-2xl py-4xl">
            <div className="flex flex-col gap-xs">
              <h1 className="display-xs-bold text-text-primary">
                Add Ultimate Beneficial Owner
              </h1>
              <p className="txt-small-regular text-text-secondary">
                A control-only UBO has no stake or share allocation - only a
                control type that explains the basis of their influence.
              </p>
            </div>

            <AddUltimateBeneficialOwnerForm
              corporationId={corporationId}
              onCancel={onClose}
              onSuccess={onSuccess}
              onError={onError}
            />
          </div>
        )}
      </FullscreenModalContent>
    </FullscreenModal>
  );
};
